    // Universal Quantity Table Script - Works for Product Pages & Product Cards
    (function() {
        'use strict';

        let observer = null;
        let isInitialized = false;

        function initQuantityTableObserver() {
            // Disconnect existing observer to prevent duplicates
            if (observer) {
                observer.disconnect();
            }

            // Create observer to watch for table injection
            observer = new MutationObserver((mutations) => {
                // Skip if facet update is in progress
                if (window.facetUpdateInProgress) {
                    console.log('⏸️ Skipping quantity table update - facet update in progress');
                    return;
                }

                mutations.forEach((mutation) => {
                    if (mutation.addedNodes.length) {
                        processExistingTables();
                    }
                });
            });

            // Start observing
            const targetNode = document.querySelector('body');
            const config = { childList: true, subtree: true };
            observer.observe(targetNode, config);

            console.log('✅ Quantity table script initialized');
            
            // Wait much longer to let BSS app fully inject ALL cards including the first one
            setTimeout(function(){
                processExistingTables();
            }, 5000);  // Don't check anything for 5 seconds
            setTimeout(function(){
                processExistingTables();
            }, 6500);
            setTimeout(function(){
                processExistingTables();
            }, 8000);
            setTimeout(function(){
                processExistingTables();
            }, 10000);
        }

        function processExistingTables() {
            console.log('processExistingTables');
            // Check for product page tables
            const tableWrapper = document.querySelector('.bss-b2b-qty-table-wrapper:not([data-processed])');
            if (tableWrapper && isTableFullyLoaded(tableWrapper)) {
                rebuildQuantityTable(tableWrapper, 'product-page');
                tableWrapper.dataset.processed = 'true';
            }

        // Check for product card tables
        const cardTables = document.querySelectorAll('.bss-b2b-qb-table:not([data-processed])');
        
        cardTables.forEach((cardTable, index) => {
            // Only process if it has content
            if (cardTable.children.length > 0) {
                    
                const loadStatus = isTableFullyLoaded(cardTable);
                
                if (loadStatus === 'ready') {
                    rebuildQuantityTable(cardTable, 'product-card');
                    cardTable.dataset.processed = 'true';
                } else if (loadStatus === 'injecting') {
                    // BSS is actively injecting - wait, but count attempts to avoid infinite loop
                    const injectingCount = parseInt(cardTable.dataset.injectingCount || '0') + 1;
                    cardTable.dataset.injectingCount = injectingCount;
                    
                    if (injectingCount >= 10) {
                        // BSS is stuck - give up and process with base price
                        console.warn(`⚠️ Table stuck injecting - processing with base price only`);
                        rebuildQuantityTable(cardTable, 'product-card');
                        cardTable.dataset.processed = 'true';
                    }
                } else if (loadStatus === 'no-rows') {
                    // BSS app hasn't started injecting yet
                    const attemptCount = parseInt(cardTable.dataset.attemptCount || '0') + 1;
                    cardTable.dataset.attemptCount = attemptCount;
                    
                    if (attemptCount >= 5) {
                        // After 5 attempts, give up and process with just base price
                        console.warn(`⚠️ No BSS rows found - processing with base price only`);
                        rebuildQuantityTable(cardTable, 'product-card');
                        cardTable.dataset.processed = 'true';
                    }
                }
                }
            });
        }

    function isTableFullyLoaded(container) {
        // For product cards, check for BSS app's deeply nested structure
        if (container.classList.contains('bss-b2b-qb-table')) {
            // Check if BSS app has started injecting content
            const hasWrapper = container.querySelector('.bss-b2b-qty-table-wrapper');
            const bssRows = container.querySelectorAll('.bss-b2b-qty-table-row[data-min]');
            
            // Validation logging removed for cleaner console
            
            // If wrapper exists but no rows, BSS is actively injecting - definitely wait
            if (hasWrapper && bssRows.length === 0) {
                return 'injecting';
            }
                
            // If no wrapper and no rows, BSS hasn't started yet
            if (!hasWrapper && bssRows.length === 0) {
                return 'no-rows';
            }
                
            // Verify rows have actual price data
            let hasValidPrices = true;
            bssRows.forEach((row, idx) => {
                const priceCell = row.querySelector('td:nth-child(2)');
                if (!priceCell || !priceCell.textContent.includes('$')) {
                    hasValidPrices = false;
                }
            });
            
            if (!hasValidPrices) {
                return 'waiting-prices';
            }
            
            return 'ready';
            }
            
            // For product pages, check for wrapper structure
            if (container.classList.contains('bss-b2b-qty-table-wrapper')) {
                const rows = container.querySelectorAll('.bss-b2b-qty-table-row[data-min]');
                return rows.length > 0 ? 'ready' : 'no-rows';
            }
            
            return 'unknown';
        }

    function rebuildQuantityTable(container, context) {
        try {

                let variantPrice = 0;
                let originalRows = [];

            if (context === 'product-page') {
                // Product page - just extract from first BSS row as base price
                const firstRow = container.querySelector('.bss-b2b-qty-table-row');
                if (firstRow) {
                    const priceCell = firstRow.querySelector('td:nth-child(2)');
                    if (priceCell) {
                        variantPrice = parseFloat(priceCell.textContent.replace(/[^0-9.]/g, ''));
                    }
                }
                
                if (!variantPrice || variantPrice === 0) {
                    console.warn('⚠️ Could not find variant price for product page');
                    return;
                }

                originalRows = container.querySelectorAll('.bss-b2b-qty-table-row[data-min]');

            } else if (context === 'product-card') {
                // Product card - get price from data attributes
                variantPrice = parseFloat(container.dataset.variantPrice) / 100;
                
                if (!variantPrice) {
                    // Fallback: try to get price from the card's price element
                    const card = container.closest('product-card');
                    const priceElement = card ? card.querySelector('.price .money') : null;
                    if (priceElement) {
                        variantPrice = parseFloat(priceElement.textContent.replace(/[^0-9.]/g, ''));
                    }
                }

                if (!variantPrice) {
                    console.warn('⚠️ Could not find variant price for product card');
                    return;
                }

                // Find original BSS rows within the nested structure
                originalRows = container.querySelectorAll('.bss-b2b-qty-table-row[data-min]');
            }

            // Prepare data structure for the new table
            const quantities = ['1+'];
            const minimumQuantity = parseInt(container.getAttribute('data-minimum-quantity'));
            const enquiryOnly = container.getAttribute('data-enquiry-only');
            const loggedIn = document.querySelector('body').classList.contains("logged-in");
            if(minimumQuantity > 0){
                quantities[0] = minimumQuantity+"+";
            }
            const prices = [variantPrice];
            const memberPrices = [variantPrice * 0.95]; // 5% discount for members

            // Extract data from original table rows
            originalRows.forEach(row => {
                const minQty = row.getAttribute('data-min');
                if (minQty) {
                    const quantity = minQty + '+';
                    const priceCell = row.querySelector('td:nth-child(2)');
                    if (priceCell) {
                        const price = parseFloat(priceCell.textContent.replace(/[^0-9.]/g, ''));
                        if (price > 0) {
                            quantities.push(quantity);
                            prices.push(price);
                            memberPrices.push(price * 0.95);
                        }
                    }
                }
            });

            // Build new table HTML with inline styles for consistent sizing
            const tableHTML = `
                <style>
                    .quantity-discounts { font-size: 13px !important; line-height: 1.4 !important; }
                    .quantity-discounts th, .quantity-discounts td { padding: 8px !important; font-size: 13px !important; }
                    .quantity-discounts .price { font-weight: 600 !important; font-size: 13px !important; }
                    .quantity-discounts .gst { font-size: 11px !important; color: #666 !important; display: block !important; }
                    .quantity-discounts .modal-trigger svg { width: 14px !important; height: 14px !important; vertical-align: middle !important; margin-left: 4px !important; }
                </style>
                <table class="table table-bordered table-condensed quantity-discounts">
                    <thead>
                        <tr>
                            <th class="header">Quantity discounts:</th>
                            ${quantities.map(qty => `<th class="units">${qty}</th>`).join('')}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">
                                ${enquiryOnly ? '<b>Price</b> (Per Bag)' : '<b>Non-Member</b>'}
                            </th>
                            ${prices.map((price, index) => `
                                <td>
                                    <span class="price" data-member="${enquiryOnly && index > 0 ? Number(Math.ceil(price/.95 + 'e' + 2) + 'e-' + 2) : price.toFixed(2)}">$${price.toFixed(2)}</span>
                                    <span class="gst">(inc. GST)</span>
                                </td>
                            `).join('')}
                        </tr>
                        <tr ${enquiryOnly ? 'class="d-none"' : ''}>
                            <th scope="row">
                                <a href="#" data-toggle="modal" data-target="#member-benefit">
                                    <b>Member</b><span class="modal-trigger"><svg height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg"><g id="Layer_2" data-name="Layer 2"><circle cx="12" cy="12" fill="#2196f3" r="10"/><g fill="#fff"><circle cx="12" cy="7.38" r="1.25"/><path d="m12 17.88a1 1 0 0 1 -1-1v-5a1 1 0 0 1 0-2h1a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1z"/><path d="m13 17.88h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2z"/></g></g></svg></span>
                                </a>
                            </th>
                            ${memberPrices.map((price, index) => `
                                <td>
                                    <span class="price">$${price.toFixed(2)}</span>
                                    <span class="gst">(inc. GST)</span>
                                </td>
                            `).join('')}
                        </tr>
                    </tbody>
                </table>
            `;

            const tableHTMLLoggedIn = `
                <style>
                    .quantity-discounts { font-size: 13px !important; line-height: 1.4 !important; }
                    .quantity-discounts th, .quantity-discounts td { padding: 8px !important; font-size: 13px !important; }
                    .quantity-discounts .price { font-weight: 600 !important; font-size: 13px !important; }
                    .quantity-discounts .gst { font-size: 11px !important; color: #666 !important; display: block !important; }
                    .quantity-discounts .modal-trigger svg { width: 14px !important; height: 14px !important; vertical-align: middle !important; margin-left: 4px !important; }
                </style>
                <table class="table table-bordered table-condensed quantity-discounts table-loggedin">
                    <thead>
                        <tr>
                            <th class="header">Quantity discounts:</th>
                            ${quantities.map(qty => `<th class="units">${qty}</th>`).join('')}
                        </tr>
                    </thead>
                    <tbody>
                        <tr ${enquiryOnly ? 'class="d-none3"' : ''}>
                            <th scope="row">
                                <a href="#" data-toggle="modal" data-target="#member-benefit">
                                    <b>Member</b><span class="modal-trigger"><svg height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg"><g id="Layer_2" data-name="Layer 2"><circle cx="12" cy="12" fill="#2196f3" r="10"/><g fill="#fff"><circle cx="12" cy="7.38" r="1.25"/><path d="m12 17.88a1 1 0 0 1 -1-1v-5a1 1 0 0 1 0-2h1a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1z"/><path d="m13 17.88h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2z"/></g></g></svg></span>
                                </a>
                            </th>
                            ${prices.map((price, index) => `
                                <td>
                                    <span class="price">$${index == 0 ? memberPrices[0].toFixed(2) : price.toFixed(2)}</span>
                                    <span class="gst">(inc. GST)</span>
                                </td>
                            `).join('')}
                        </tr>
                    </tbody>
                </table>
            `;

            // Replace the original table and show it
            var oldTable = container.querySelector('.bss-b2b-cart-item-qty-table');
            if(oldTable) oldTable.style.display = 'none';
            var thumbSelected = container.closest('.js-pagination-result');
            var parentResult = thumbSelected.parentNode;
            if(loggedIn && !enquiryOnly){
                if (thumbSelected == parentResult.firstElementChild) {
                    container.insertAdjacentHTML( 'beforeend', tableHTMLLoggedIn );
                } else {
                    container.innerHTML = tableHTMLLoggedIn;
                }
            } else{
                if (thumbSelected == parentResult.firstElementChild) {
                    container.insertAdjacentHTML( 'beforeend', tableHTML );
                } else {
                    container.innerHTML = tableHTML;
                }
            }
            container.style.display = 'block';

        } catch (error) {
            console.error('❌ Error rebuilding quantity table:', error);
        }
    }

        function initModalHandlers() {
            document.addEventListener('click', function(e) {
                const memberBenefitLink = e.target.closest('[data-target="#member-benefit"]');
                if (memberBenefitLink) {
                    e.preventDefault();
                    openModal();
                }
            });

            // Modal functions
            function openModal() {
                const modal = document.getElementById('member-benefit');
                const overlay = document.querySelector('.modal-overlay');
                
                if (modal && overlay) {
                    modal.style.display = 'block';
                    overlay.style.display = 'block';
                    document.body.style.overflow = 'hidden';
                }
            }

            function closeModal() {
                const modal = document.getElementById('member-benefit');
                const overlay = document.querySelector('.modal-overlay');
                
                if (modal && overlay) {
                    modal.style.display = 'none';
                    overlay.style.display = 'none';
                    document.body.style.overflow = '';
                }
            }

            // Close modal handlers
            document.addEventListener('click', function(e) {
                if (e.target.matches('.modal-overlay, .close, .btn-secondary')) {
                    closeModal();
                }
            });

            document.addEventListener('keydown', function(e) {
                if (e.key === 'Escape') {
                    closeModal();
                }
            });
        }

        function reinitializeAfterFacetUpdate() {
            // Wait for facet update to complete
            setTimeout(() => {
                console.log('🔄 Reinitializing quantity tables after facet update');
                
                // Reset processed flags so tables can be rebuilt
                document.querySelectorAll('[data-processed]').forEach(el => {
                    el.removeAttribute('data-processed');
                });
                
                // Reinitialize observer
                initQuantityTableObserver();
            }, 200);
        }

        // Initialize when DOM is ready
        function initialize() {
            if (isInitialized) return;
            
            initQuantityTableObserver();
            initModalHandlers();
            
        // Listen for facet filter updates
        document.addEventListener('on:facet-filters:updated', reinitializeAfterFacetUpdate);
        
        isInitialized = true;
        }

        // Initialize immediately if DOM is ready, otherwise wait
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initialize);
        } else {
            initialize();
        }

        // Expose reinitialize function globally for manual calls
        window.reinitializeQuantityTables = reinitializeAfterFacetUpdate;

    })();